<template>
  <div class="main-content">
    <div class="page-header">
      <h2 class="header-title">Факультет / Спец.</h2>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" v-for="(item, index) in tabs" :key="index">
          <a
            class="nav-link"
            href="#"
            :class="{ active: index == tab_active }"
            @click.prevent="tabChange(index)"
          >
            {{ item.name_ru }}
          </a>
        </li>
      </ul>
      <div class="card-body">
        <div class="tab_block" v-if="tab_active == 0">
          <Faculty />
        </div>
        <div class="tab_block" v-if="tab_active == 1">
          <Direction />
        </div>
        <div class="tab_block" v-if="tab_active == 2">
          <Speciality />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Faculty from "@/components/FacultySpec/Faculty.vue";
import Direction from "@/components/FacultySpec/Direction.vue";
import Speciality from "@/components/FacultySpec/Speciality.vue";

export default {
  name: "FacultySpec",
  components: {
    Faculty,
    Direction,
    Speciality,
  },
  data() {
    return {
      tabs: [
        { name_ru: "Факультет" },
        { name_ru: "Напрпавления" },
        { name_ru: "Cпециальность" },
      ],
      tab_active: 0,
    };
  },
  methods: {
    tabChange(i) {
      this.tab_active = i;
    },
  },
  mounted() {
    this.$nextTick(function () {});
  },
};
</script>
<style lang="scss" scoped>
.card {
  overflow: hidden;
}
.nav-tabs > li > a {
  font-weight: 500;
}
.nav-tabs > li > a.active.nav-link {
  border-bottom: none;
  color: #fff;
  background-color: #886cff;
}
.nav-tabs {
  border-bottom: 1px solid #b6a6ff;
}
</style>
